export const PERSONA_COLORS: Record<string, string> = {
  despretensiosa: "#FF7F7F",
  romantica: "#FFB6C1",
  cosmopolita: "#9B59B6",
  sexy: "#FF8C00",
  classica: "#3498DB",
  basica: "#87CEEB",
  mistica: "#8B5CF6",
  criativa: "#2ECC71",
  dramatica: "#E74C3C",
  ludica: "#FF69B4",
  natural: "#90EE90",
  dinamica: "#F1C40F",
};
